import React, { useEffect } from "react";
import { formatNumber } from "../../../../utils/tools";
import { InputContainer } from "../../DepositElements";

const DatosTransferenciaVnzla = ({ form, setForm, handleChange, pais }) => {
  useEffect(() => {
    if (pais === "eur") {
      setForm({
        ...form,
        bancoNombre: "",
        numeroCuenta: "",
        nombreApellido: "",
        cedula: "",
        monto2: "",
      });
    } else if (pais === "arg") {
      setForm({
        ...form,
        bancoNombre: "",
        tipoCuenta: "",
        numeroCuenta: "",
        nombreApellido: "",
        cedula: "",
        monto2: "",
        cuit: "",
      });
    } else {
      setForm({
        ...form,
        bancoNombre: "",
        tipoCuenta: "",
        numeroCuenta: "",
        nombreApellido: "",
        cedula: "",
        monto2: "",
      });
    }
  }, []);
  return (
    <div>
      <InputContainer>
        <label>NOMBRE DEL BANCO</label>

        {pais === "peru" ? (
          <select
            name="bancoNombre"
            onChange={handleChange}
            value={form.bancoNombre}
            required
          >
            <option value="">SELECCIONE UN BANCO</option>
            <option value="BCP">BCP</option>
            <option value="ScotiaBank">ScotiaBank</option>
            <option value="BBVA">BBVA</option>
          </select>
        ) : (
          <input
            type="text"
            name="bancoNombre"
            placeholder="NOMBRE DEL BANCO"
            value={form.bancoNombre}
            onChange={handleChange}
            required
          />
        )}
      </InputContainer>

      {pais !== "eur" && pais !== "arg" && (
        <InputContainer>
          {pais === "mexico" ? (
            <>
              <label>CLAVE INTERBANCARIA</label>
              <input
                type="text"
                value={form.tipoCuenta}
                placeholder="CLAVE INTERBANCARIA"
                onChange={handleChange}
                name="tipoCuenta"
                required
              />
            </>
          ) : (
            <>
              <label>TIPO DE CUENTA:</label>
              {pais === "guatemala" ? (
                <input
                  type="text"
                  value={form.tipoCuenta}
                  placeholder="INGRESE EL TIPO DE CUENTA"
                  onChange={handleChange}
                  name="tipoCuenta"
                  required
                />
              ) : (
                <select
                  value={form.tipoCuenta}
                  name="tipoCuenta"
                  onChange={handleChange}
                  required
                >
                  <option value="">SELECCIONE EL TIPO DE CUENTA</option>
                  <option value="ahorro">Ahorro</option>
                  <option value="corriente">Corriente</option>
                  {pais === "chile" && (
                    <>
                      <option value="vista">Vista</option>
                      <option value="rut">RUT</option>
                    </>
                  )}
                </select>
              )}
            </>
          )}
        </InputContainer>
      )}

      <InputContainer>
        <label>{pais === "arg" ? "CBU" : "CTA. NÚMERO"}:</label>
        <input
          type="text"
          name="numeroCuenta"
          placeholder={pais === "arg" ? "CBU" : "NÚMERO DE CUENTA"}
          value={form.numeroCuenta}
          onChange={handleChange}
          required
        />
      </InputContainer>

      {pais === "arg" && (
        <InputContainer>
          <label>ALIAS DEL CBU</label>
          <input
            type="text"
            value={form.tipoCuenta}
            placeholder="ALIAS DEL CBU"
            onChange={handleChange}
            name="tipoCuenta"
            required
          />
        </InputContainer>
      )}

      <InputContainer>
        <label>NOMBRES Y APELLIDOS:</label>
        <input
          type="text"
          name="nombreApellido"
          placeholder="NOMBRES Y APELLIDOS"
          value={form.nombreApellido}
          onChange={handleChange}
          required
        />
      </InputContainer>
      <InputContainer>
        {pais !== "chile" ? (
          <label>
            {pais === "peru" || pais === "eur" || pais === "arg"
              ? "DNI"
              : "DOCUMENTO DE IDENTIDAD"}{" "}
            {pais === "guatemala" && "(DPI)"}:
          </label>
        ) : (
          <label>RUT:</label>
        )}

        <input
          type="text"
          name="cedula"
          value={form.cedula}
          placeholder="DOCUMENTO DE IDENTIDAD"
          onChange={handleChange}
          required
        />
      </InputContainer>
      {pais === "arg" && (
        <InputContainer>
          <label>CUIT/CUIL:</label>
          <input
            type="text"
            name="cuit"
            value={form.cuit}
            placeholder="CUIT/CUIL"
            onChange={handleChange}
            required
          />
        </InputContainer>
      )}
      <InputContainer>
        <label>MONTO:</label>
        <input
          type="text"
          name="monto2"
          value={form.monto2}
          placeholder="0,00"
          onChange={(e) => handleChange(formatNumber(e))}
          required
        />
      </InputContainer>
    </div>
  );
};

export default DatosTransferenciaVnzla;
